import { render, staticRenderFns } from "./Bills.vue?vue&type=template&id=5805a9c2&scoped=true&"
import script from "./Bills.vue?vue&type=script&lang=js&"
export * from "./Bills.vue?vue&type=script&lang=js&"
import style0 from "./Bills.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Bills.vue?vue&type=style&index=1&id=5805a9c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5805a9c2",
  null
  
)

export default component.exports